import { makeDateSeries } from '@local_modules/generic/dates/make-date-series/index.js'
import { activateOptionSelector } from '../../../../modules/option-selector/index.js'

export function showSelectors (changeAction, browserAppAccount) {
  console.log('showSelectors', browserAppAccount)

  const optionSelectorShow = [
    'dates',
    'decimals',
    'currencies',
    'optionsCurrencies',
    'optionsGroupBy'
  ]

  const dateseries = makeDateSeries(browserAppAccount.data.firstLedgerDate)

  const optionSelectorParams = activateOptionSelector({
    containerId: 'optionSelector',
    show: optionSelectorShow,
    hide: ['currencies'],
    default: 'organisations',
    onChange: changeAction,
    dateseries,
    // currencies: browserAppAccount.data.currenciesForAccount,
    modules: {
      optionCurrencies: {
        currencies: browserAppAccount.data.currenciesForAccount,
        default: 'XXX'
      },
      optionsGroupBy: {
        options: [
          {
            label: 'Contacts',
            value: 'contactKey'
          },
          {
            label: 'Accounts',
            value: 'accountKey'
          },
          {
            label: 'Entities',
            value: 'entityKey'
          }
        ],
        default: ['contactKey']
      }
    },
    dateOptions: {
      default: {
        from: 'relative:-6',
        to: 'relative:0'
      }
    },
    customSettings: {
      organisations: mapOrganisations(browserAppAccount),
      orgOptions: {
        allowConso: false,
        allowMultiple: true,
        allowSeveral: true
        // defaultIndex: 0
      }
    }
  })
  return optionSelectorParams
}

function mapOrganisations (browserAppAccount) {
  const accountingsOrganisations = browserAppAccount.data?.entities
  // console.log('accountData', accountData)

  const organisations = accountingsOrganisations?.map(function (accountOrganisation) {
    return accountOrganisation
  })
  return organisations
}
